export enum NotificationMessageType {
    PreDeployment = 1
    , PostDeployment = 2
    , EnableMessage = 3
    , DisableMessage = 4
}


// WEBPACK FOOTER //
// ./src/enums/notificationMessageType.enum.ts